<template>
  <div class="mx-2">
    <v-col class="container pl-1 pt-4 pb-6">
      <ToolbarTitles :title="title" />
    </v-col>
    <TableWithSearch
      :items="getTags"
      :headers="allHeaders"
      :openDialog="openDialog"
      :showPagination="false"
      @headersUpdated="updateHeaders"
      @refreshItems="refreshItems"
      :showRefresh="true"
    />
    <v-dialog
      v-model="open"
      :max-width="maxWidth"
      persistent
      @keydown.esc="reset(false)"
    >
      <FormTags
        :key="formKey"
        :maxWidth="maxWidth"
        :title="modeForm"
        @save="save"
        @cancel="reset"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </div>
</template>
<script>
import TableWithSearch from "../../Complement/TableWithSearch.vue";
import FormTags from "./Form/FormTags.vue";
import DeleteDialog from "../../Complement/DeleteDialog.vue";
import Snackbar from "../../Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";

export default {
  name: "labels",
  components: {
    TableWithSearch,
    FormTags,
    DeleteDialog,
    Snackbar,
    ToolbarTitles,
  },
  data() {
    return {
      title: this.$tc("nav.labels"),
      headers: [
        {
          text: "Nombre",
          value: "text",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Alcance",
          value: "scope",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Color",
          value: "color",
          class: "primary secondary--text",
          align: "center",
          visible: true,
          sortable: false,
          width: "100px",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      showForm: false,
      showDelete: false,
      itemDelete: null,
      alert: false,
      textAlert: "",
      color: "",
      scope: "",
      formKey: 0,
      titleDelete: this.$tc("reports.deleteLabel"),
      modoItem: "",
      maxWidth: "550px",
      itemToDelete: null,
      oldItems: null,
      titleTable: "Labels",
    };
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    this.$store.dispatch("tags/getTags");
  },
  computed: {
    getTags() {
      return this.$store.state.tags.tags;
    },
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    modeForm: {
      get() {
        return this.$store.state.tags.modeForm;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return this.$store.state.tags.openform;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete() {
      return this.$store.state.tags.openDelete;
    },
  },
  methods: {
    async refreshItems() {
      await this.$store.dispatch("tags/getTags");
    },
    updateHeaders(headers) {
      const updatedColums = headers;

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }
      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    async openDialog(type, item) {
      this.typeForm = type;
      this.formKey++;
      switch (this.typeForm) {
        case "add":
          this.modoItem = "add";
          this.oldItems = null;
          this.$store.commit("tags/setModeForm", this.$tc("reports.addLabels"));
          this.$store.commit("tags/setOpenform", true);
          break;
        case "edit":
          this.modoItem = "edit";
          this.$store.commit("tags/setEditTag", item);
          this.$store.commit(
            "tags/setModeForm",
            this.$tc("reports.editLabels")
          );
          this.$store.commit("tags/setOpenform", true);
          break;
        case "delete":
          this.$store.commit("tags/setOpenDelete", true);
          this.itemToDelete = item;
          break;
        default:
          break;
      }
    },

    reset(value) {
      this.$store.commit("tags/setOpenform", value);
      this.$store.commit("tags/setEditTag", []);
    },

    cancelDelete() {
      this.$store.commit("tags/setOpenDelete", false);
    },

    deleteItem() {
      this.$store.commit("tags/setDeleteItem", this.itemToDelete);
      this.$store
        .dispatch("tags/deleteTags")
        .then(() => {
          this.$store.commit("tags/setOpenDelete", false);
          this.showAlert(this.$tc("reports.deleteLabelSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
          this.$store.commit("tags/setOpenDelete", false);
        });
    },

    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addTag(items);
          break;
        case "edit":
          this.editTag(items);
          break;
        default:
          break;
      }
    },

    sendEdit(updatedItem) {
      this.$store.commit("tags/setEditTag", updatedItem);
      this.$store
        .dispatch("tags/editTag")
        .then(() => {
          this.showAlert(this.$tc("reports.editLabelSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },

    editTag(items) {
      const changes = {};
      const itemOld = this.$store.state.tags.editTag;
      if (itemOld.text !== items.text) {
        changes.nombre = items.text;
      }

      if (itemOld.description !== items.description) {
        changes.descripcion = items.description;
      }

      if (itemOld.color !== items.color) {
        changes.color = items.color;
      }
      if (itemOld.scope !== items.scope) {
        changes.scope = items.scope;
      }

      if (Object.keys(changes).length > 0) {
        const updatedItem = { etiquetaId: itemOld.id, ...changes };
        this.sendEdit(updatedItem);
      } else {
        this.showAlert(this.$tc("reports.editLabelAlert"), "#f1c232");
      }
    },

    async addTag(items) {
      let payload = {
        nombre: items.text,
        descripcion: items.description,
        color: items.color,
        alcance: items.scope,
      };

      await this.$store.commit("tags/setNewTag", payload);
      this.$store
        .dispatch("tags/addTag")
        .then(() => {
          this.showAlert(this.$tc("reports.saveLabelSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
  },
};
</script>
